import { Component, computed, inject, input } from '@angular/core';

import { CmsContent } from '@fcom/core-api';
import { DataCloudService } from '@fcom/common/datacloud/services/datacloud.service';
import { ConfigService } from '@fcom/core';

import { toLinkData } from '../../services/template/data-mappers';

export const ALL_DESTINATIONS_LINK_MASTER_CONTENT_ID = 1239748;

@Component({
  selector: 'cms-text-link',
  template: `
    <fin-text-link
      class="mr-large-b block"
      [target]="cmsTarget()"
      [teaserTitle]="content().teaserTitle"
      [colorClass]="colorClass()"
      (linkClick)="onClick()"
    />
  `,
  standalone: false,
})
export class CmsTextLinkComponent {
  private dataCloudService = inject(DataCloudService);
  private configService = inject(ConfigService);

  content = input.required<CmsContent>();
  colorClass = input<string>();

  cmsTarget = computed(() => {
    const content = this.content();
    const url =
      // for the duration of the AB test, we patch the url with round trip prices always everywhere and for all customers
      this.configService.cfg.isPersonalisedDestinationsEnabled &&
      content.masterContentId === ALL_DESTINATIONS_LINK_MASTER_CONTENT_ID
        ? `${content.target.url}?roundTripPrices=true`
        : content.target.url;
    return toLinkData({ ...content.target, url });
  });

  onClick(): void {
    if (this.content().masterContentId === ALL_DESTINATIONS_LINK_MASTER_CONTENT_ID) {
      this.dataCloudService.destinationListAllDestinationsClick();
    }
  }
}
